import React from "react";
import { Layout } from "antd";
import { Route, Routes } from "react-router-dom";
import AuthLayout from "./auth.dashboard";

import HomePage from "../pages/home";
import SignupPage from "../pages/signup";
import LoginPage from "../pages/signin";
import TenantsPage from "../pages/tenants/index";
import TenantsMaintenancePage from "../pages/tenants/maintenance";
import LandlordsPage from "../pages/landlords";
import NotFoundPage from "../pages/404";
import PropertyPage from "../pages/landlord/property/";
import UnitPage from "../pages/landlord/property/unit";
import UnitsPage from "../pages/landlord/property/units";
import BankingPage from "../pages/landlord/property/banking";
import LeaseDetailsPage from "../pages/landlord/lease";
import ApplicantsPage from "../pages/landlord/applicants";
import ApplicantsNewPage from "../pages/landlord/applicants/new";
import ApplicantsScreenPage from "../pages/landlord/applicants/screened";
import ApplicantsSendPage from "../pages/landlord/applicants/send";
import MaintenancePage from "../pages/landlord/maintenance";
import PaymentsPage from "../pages/landlord/payments";
import ProfilePage from "../pages/myprofile";
import MySettings from "../pages/mysettings";

import DonatePage from "../pages/donate";
import EmailVerificationPage from "../pages/email-verfication";
// import FeedPage from "../pages/feed";
import AboutPage from "../pages/about";
import PrivacyPage from "../pages/about/privacy";
import TermsPage from "../pages/about/terms";
import IDVerify from "../pages/tenants/id";
import RentalsPage from "../pages/rentals";
import RentalsListPage from "../pages/rentals/list";
import RentalsPropertyPage from "../pages/rentals/property";
import LeaseChannelPage from "../pages/landlord/lease/channel";
import WaitVerifyPage from "../pages/wait-verify";

import ProtectedRoute from "../components/ProtectedRoute";
import LandlordDashboard from "../pages/landlord/dashboard";
import LandlordProfile from "../pages/landlord/profile";
import LandlordMyPosts from "../pages/landlord/mypost";

const { Content } = Layout;

const LandingLayout = () => {
  const LandlordLayout = () => {
    return (
      <ProtectedRoute>
        <AuthLayout>
          <Routes>
            <Route path="dashboard" element={<LandlordDashboard />} />
            <Route path="profile" element={<LandlordProfile />} />
            <Route path="property" element={<PropertyPage />} />
            <Route path="property/unit" element={<UnitPage />} />
            <Route path="property/units" element={<UnitsPage />} />
            <Route path="property/banking" element={<BankingPage />} />
            <Route path="applicants" element={<ApplicantsPage />} />
            <Route path="applicants/new" element={<ApplicantsNewPage />} />
            <Route
              path="applicants/screened"
              element={<ApplicantsScreenPage />}
            />
            <Route path="applicants/send" element={<ApplicantsSendPage />} />
            <Route path="lease" element={<LeaseDetailsPage />} />
            <Route path="/lease/channel" element={<LeaseChannelPage />} />
            <Route path="maintenance" element={<MaintenancePage />} />
            <Route path="payments" element={<PaymentsPage />} />
            <Route path="myposts" element={<LandlordMyPosts />} />
          </Routes>
        </AuthLayout>
      </ProtectedRoute>
    );
  };

  return (
    <Layout>
      <Content>
        <Routes>
          <Route path="/" element={<HomePage />} />

          {/* Auth Pages */}
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/signin" element={<LoginPage />} />
          <Route
            path="/email-verification"
            element={<EmailVerificationPage />}
          />
          <Route path="/verify" element={<WaitVerifyPage />} />

          {/* Landlord Pages */}
          <Route path="/landlord/*" element={<LandlordLayout />} />

          <Route path="/home/" element={<HomePage />} />

          <Route path="/about" element={<AboutPage />} />
          <Route path="/about/privacy" element={<PrivacyPage />} />
          <Route path="/about/terms" element={<TermsPage />} />
          <Route path="/tenants/" element={<TenantsPage />} />
          <Route
            path="/tenants/maintenance"
            element={<TenantsMaintenancePage />}
          />
          <Route path="/tenants/id" element={<IDVerify />} />
          <Route path="/landlords/" element={<LandlordsPage />} />

          <Route path="/donate" element={<DonatePage />} />
          <Route path="/rentals" element={<RentalsPage />} />
          <Route path="/rentals/list" element={<RentalsListPage />} />
          <Route path="/rentals/property" element={<RentalsPropertyPage />} />
          <Route path="/:username" element={<ProfilePage />} />
          <Route path="/:username/settings" element={<MySettings />} />
          {/* <Route path="/:username/status/:id" element={<FeedPage/>}/> */}

          <Route path="/*" element={<NotFoundPage />} />
        </Routes>
      </Content>
    </Layout>
  );
};

export default LandingLayout;
